/* eslint-disable react/no-unescaped-entities */
import React, { useState } from "react";
import {
  Container,
  SlideFade,
  Box,
  FormControl,
  FormLabel,
  Flex,
  Button,
  Textarea,
  Heading,
  useToast,
  FormErrorMessage,
  Stack,
} from "@chakra-ui/react";
// import styles from "../styles/Home.module.css";
// import Head from "next/head";
import { useForm } from "react-hook-form";
import Nav from "./navbar";

const Base64 = () => {
  const [decodedResult, setDecodedResult] = useState("");
  const toast = useToast();

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm();

  async function onSubmit(values: any) {
    console.log(JSON.stringify(values, null, 1));
    try {
      const res = await fetch(
        `https://api.raghavkeinth.dev/transactions/base64/decode`,
        {
          method: "POST",
          body: JSON.stringify(values, null, 1),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await res.text();
      setDecodedResult(data);
      toast({
        title: "Message Submitted",
        description: "Decoded data received successfully!",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    } catch (e) {
      console.error(e);
      toast({
        title: "Form Not Submitted",
        description: "Please try again later",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }

  return (
    <div >
      {/* <Head>
        <title>Raghav | Base64</title>
        <meta
          name="description"
          content="Raghav | Mobile Application Developer"
        />
        <link rel="icon" href="/profile_picture.png" />
      </Head> */}

      <main>
        <Stack position="sticky" top={0} zIndex={1} width="full">
          <Nav pageName={"Base64"} />
        </Stack>
        <Container maxW="container.lg" mt={["5", "10"]} mb={["5", "10"]}>
          <SlideFade in offsetY={80}>
          <Box p={8} borderWidth={1} borderRadius={8} boxShadow="lg">
                <Heading size={"lg"}>Base64 Decoder</Heading>

                <Box my={4} textAlign="left">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <FormControl isRequired mt={6}>
                      <FormLabel htmlFor="base64">
                        Base64 Encoded String
                      </FormLabel>
                      <Textarea
                        id="base64"
                        placeholder="Enter Encoded string"
                        {...register("base64", {
                          required: "This is required",
                          minLength: {
                            value: 4,
                            message: "Minimum length should be 4",
                          },
                        })}
                      />
                      {/* <FormErrorMessage>
                        {errors.base64 && errors.base64.message}
                      </FormErrorMessage> */}
                    </FormControl>

                    <Button
                      variant="solid"
                      width="full"
                      mt={4}
                      type="submit"
                      loadingText="Submitting"
                      isLoading={isSubmitting}
                      colorScheme={"blue"}
                    >
                      Submit
                    </Button>
                  </form>
                </Box>
              </Box>
              
          </SlideFade>
        </Container>

            <Flex width="full" align="center" justifyContent="center">
              
              {decodedResult && (
                <Box mt={4} overflowX="auto" maxW="100%">
                  <Heading size="md">Decoded Result:</Heading>
                  <pre style={{ whiteSpace: "pre", wordWrap: "normal" }}>
                    {decodedResult}
                  </pre>
                </Box>
              )}
            </Flex>
      </main>
    </div>
  );
};

export default Base64;
